module.exports = {
      id: "prothomalo-com-usage",
      viewBox: "0 0 200 27",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#prothomalo-com",
      toString: function () {
        return this.url;
      }
    }